import TestStep from './TestStep';

export default class TestStepsCollection {
  testSteps: Array<TestStep>;
  version: string;
  constructor(testSteps: Array<TestStep> = []) {
    this.testSteps = [...testSteps];
    this.version = '1.0.0';
  }
}
